import { rem } from 'polished'
import styled from 'styled-components'
import LoyaltyInfiniteLogo from './LoyaltyInfiniteLogo'

/**
 * The Société Infinite brand logo — the INFINITE wordmark. Size via the `height` prop (px).
 */
const Wrapper = styled.span`
  display: inline-flex;
  align-items: center;
  line-height: 0;
`

const Wordmark = styled(LoyaltyInfiniteLogo)`
  height: 55%;
  width: auto;
`

interface Props {
  className?: string
  /** Brand-logo height in px (the wordmark scales to it). */
  height?: number
  /**
   * `gradient` (default) renders the rose-gold gradient; `dark` renders it flat in solid black.
   * @default gradient
   */
  variant?: 'gradient' | 'dark'
}

function LoyaltyInfiniteBrandLogo({ className, height = 22, variant = 'gradient' }: Props) {
  return <Wrapper className={className} style={{ height: rem(height) }}>
    <Wordmark variant={variant} />
  </Wrapper>
}

export default LoyaltyInfiniteBrandLogo
